import React, { useContext, useState, useEffect, useRef } from 'react'
import styles from './styles.module.css'
import { StudentsContext } from '../../../utils/context'
import Table from '../../../components/Table'
import Button from '../../../components/Button'
import Modal from './extraModal/TrustedPersonsModal'
import Confirmation from '../../../components/Confirmation/Confirmation'


export default function Benefits() {

  const { allForms, addMode, studentTabData, updateInitialValues, trackDeletion } = useContext(StudentsContext)

  const { values = {}, setFieldValue, setValues } = allForms || {}

  const { privileges: privilegesData } = studentTabData || {}

  const lastSyncedRef = useRef(null)

  const [modalData, setModalData] = useState(null)
  const [modalAddMode, setModalAddMode] = useState(false)
  const [selectedRow, setSelectedRow] = useState(null)
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)

  useEffect(() => {
    const dataJson = JSON.stringify(privilegesData)
    if (!addMode && privilegesData && setValues && lastSyncedRef.current !== dataJson) {
      lastSyncedRef.current = dataJson
      setValues(prev => ({
        ...prev,
        privileges: Array.isArray(privilegesData) ? [...privilegesData] : { ...privilegesData }
      }))
      if (updateInitialValues) {
        updateInitialValues('privileges', privilegesData)
      }
    }
  }, [privilegesData, addMode, setValues, updateInitialValues])

  const items = Array.isArray(values.privileges) ? values.privileges : (values.privileges?.items || [])

  const handleAdd = () => {
    setModalAddMode(true)
    setModalData({})
  }

  const handleEdit = () => {
    if (selectedRow !== null && items[selectedRow]) {
      setModalAddMode(false)
      setModalData(items[selectedRow])
    }
  }

  const handleDeleteClick = () => {
    if (selectedRow !== null && items[selectedRow]) {
      setShowDeleteConfirm(true)
    }
  }

  const handleDeleteConfirm = () => {
    if (selectedRow !== null) {
      const item = items[selectedRow]
      if (item?.xp_pf_pp && !String(item.xp_pf_pp).startsWith('new_')) {
        trackDeletion('privileges', item.xp_pf_pp)
      }
      setFieldValue('privileges', items.filter((_, i) => i !== selectedRow))
    }
    setSelectedRow(null)
    setShowDeleteConfirm(false)
  }

  const handleSaveItem = (itemData) => {
    if (!setFieldValue) return
    if (modalAddMode || !itemData.xp_pf_pp) {
      setFieldValue('privileges', [...items, itemData])
    } else {
      const updated = items.map(item =>
        item.xp_pf_pp === itemData.xp_pf_pp ? itemData : item
      )
      setFieldValue('privileges', updated)
    }
    setTimeout(() => allForms.handleSubmit(), 0)
    setModalData(null)
    setSelectedRow(null)
  }

  const closeModal = () => setModalData(null)

  return (
    <div className={styles.tabWrapper}>
      {modalData !== null && (
        <Modal
          closeModal={closeModal}
          data={modalData}
          height={'430px'}
          addMode={modalAddMode}
          tabType='privileges'
          onSave={handleSaveItem}
        />
      )}

      {showDeleteConfirm && (
        <Confirmation
          title='Вы уверены, что хотите удалить льготу?'
          acceptConfirmation={handleDeleteConfirm}
          rejectConfirmation={() => setShowDeleteConfirm(false)}
        />
      )}

      <div className={styles.qualificationForm}>
        <Table className={styles.table}>
          <thead>
            <tr>
              <th>Льгота</th>
              <th>На кого</th>
              <th>Дополнительные сведения</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, idx) => (
              <tr
                key={item.xp_pf_pp || idx}
                onClick={() => setSelectedRow(idx)}
                style={{ cursor: 'pointer', backgroundColor: selectedRow === idx ? '#DEECFF' : 'transparent' }}
              >
                <td>{item.privilegename || ''}</td>
                <td>{item.fio || ''}</td>
                <td>{item.additional || ''}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        <div className={styles.inputsRow} style={{ marginTop: '0.5rem' }}>
          <Button mode='bordered' onClick={handleAdd}>Добавить</Button>
          <Button mode='bordered' onClick={handleEdit} disabled={selectedRow === null}>Изменить</Button>
          <Button mode='bordered' onClick={handleDeleteClick} disabled={selectedRow === null}>Удалить</Button>
        </div>
      </div>
    </div>
  )
}
